module.exports = __webpack_public_path__ + "img/42.33ccca34.jpg";